import { NavLink } from 'react-router-dom';

interface SidebarNavLinkProps {
    label?: string;
    children: React.ReactElement;
    link: string;
    exact?: boolean;
    key: string | number;
}

export default ({ label, children, link, key, exact = false }: SidebarNavLinkProps) => (
    <NavLink
        exact={exact}
        activeClassName="text-blue-700 bg-gradient-to-r from-white to-blue-100 border-blue-500 border-r-4"
        className="w-full font-thin capitalize text-gray-500 dark:text-gray-200 flex items-center p-4 transition-colors duration-200 justify-start hover:text-blue-700"
        key={key}
        to={link}
    >
        <span className="text-left">{children}</span>
        <span className="mx-5 text-sm font-normal whitespace-nowrap">{label}</span>
    </NavLink>
);
